<template>
    <div id="contenedor-main-contrato-estimaciones">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
  name: 'MainContratoEstimaciones',
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
